import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  Form,
  Input,
  InputNumber,
  Select,
  useForm,
  useSelect,
} from "@pankod/refine-antd";
import { IPackage } from "../../interfaces";

export const PackageEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IPackage>({
    metaData: { populate: ["pricing_scheme"] },
  });

  const { selectProps: pricingSchemeSelect } = useSelect<IPackage>({
    resource: "pricing-schemes",
    optionLabel: "name",
    optionValue: "id",
    defaultValue: queryResult?.data?.data?.pricing_scheme?.data?.id,
    sort: [{ field: "name", order: "asc" }],
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          return formProps.onFinish?.({
            ...values,
            pricing_scheme: values.pricing_scheme?.data.id,
          });
        }}
      >
        <Form.Item label="Price" name="price">
          <InputNumber />
        </Form.Item>
        <Form.Item label="Credits" name="credits">
          <InputNumber />
        </Form.Item>
        <Form.Item label="Title" name="title">
          <Input />
        </Form.Item>
        <Form.Item label="Subtitle" name="subtitle">
          <Input />
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 8 }}
          label="Pricing scheme"
          name={["pricing_scheme", "data", "id"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...pricingSchemeSelect} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
